import { getStore } from '../store/store';

export default function isEmailAddressMasked(emailAddress: string): boolean {
    return getStore().sessionMaskedRecipients[emailAddress];
}
